// extracted by mini-css-extract-plugin
module.exports = {"locationInfo":"hPbAF","locationInfo-logo":"-fvuf","locationInfo-title":"SkJ+i","locationInfo-body":"VNHHe"};